module.exports = __webpack_public_path__ + "img/sedan.e6597739.svg";